"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateClassString = exports.range = exports.playerColorClass = void 0;
var playerColorClass = function (color, type) {
    var prefix = {
        shadow: 'player_shadow_color_',
        bg_transparent: 'player_translucent_bg_color_',
        bg: 'player_bg_color_',
    }[type];
    return "" + prefix + color;
};
exports.playerColorClass = playerColorClass;
var range = function (n) { return Array.from(Array(n).keys()); };
exports.range = range;
var generateClassString = function (classes) { return classes.join(' ').trimStart(); };
exports.generateClassString = generateClassString;
//# sourceMappingURL=utils.js.map